import { IconButton, useColorMode, Tooltip } from '@chakra-ui/react';
import CustomTooltip from 'components/shared/CustomTooltip';
import { FiMoon, FiSun } from 'react-icons/fi';

// ─────────────────────────────────────────────────────────────────────────
// ThemeToggle — accessible dark/light switch for the single-root theme.
//
//  • Uses Chakra v1's real `useColorMode` (persists to localStorage under
//    `chakra-ui-color-mode`; the pre-paint <ColorModeScript> reads it, so
//    there is no flash of the wrong theme on reload).
//  • Keyboard-operable (it's a <button>), labelled for screen readers, and
//    announces the target state via aria-label + tooltip.
//  • The icon rotate/scale transition is skipped under prefers-reduced-motion
//    (handled globally in theme/styles.js).
// ─────────────────────────────────────────────────────────────────────────
export default function ThemeToggle(props) {
	const { colorMode, toggleColorMode } = useColorMode();
	const isDark = colorMode === 'dark';
	const nextLabel = isDark ? 'Switch to light theme' : 'Switch to dark theme';

	return (
		// <CustomTooltip label={nextLabel} openDelay={400} hasArrow>
			<IconButton
				aria-label={nextLabel}
				title={nextLabel}
				onClick={toggleColorMode}
				variant='ghost'
				size='md'
				borderRadius='full'
				color='text.secondary'
				icon={isDark ? <FiSun size='18' /> : <FiMoon size='18' />}
				_hover={{ bg: 'bg.elevated', color: 'text.accent' }}
				_active={{ bg: 'bg.elevated' }}
				sx={{
					'& svg': { transition: 'transform 200ms ease' },
					'&:hover svg': { transform: 'rotate(15deg) scale(1.08)' },
				}}
				{...props}
			/>
		// </CustomTooltip>
	);
}
